import React, { Component } from "react";
import moment from "moment";
import "moment/locale/tr";
import maskText from "../helpers/maskText";
moment.locale("tr");
export default class OrderDetailInfoDetail extends Component {
  render() {
    return (
      <table
        className={"table table-bordered table-hover"}
        style={{ marginTop: 20 }}
      >
        <thead>
          <tr>
            <td>Sipariş Detayları</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {this.props.customer
                ? this.props.order[
                    this.props.customer ? "order" : "orderEnquiry"
                  ].comment
                : maskText(
                    this.props.order[
                      this.props.customer ? "order" : "orderEnquiry"
                    ].comment,
                    2
                  )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderDetailInfoDetail.js